export default __webpack_public_path__ + "./image/b867476bdc0c9be48bab2d66094558b2.png";